import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// 【AI模組化】統一從 PWA 模組匯入
import { serviceWorkerRegister } from './modules/PWA';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// 【AI模組化】呼叫 serviceWorkerRegister 進行註冊
serviceWorkerRegister();